import React, { useMemo, useContext } from "react";
import { AssigneeSelector } from "fe-shared/src/components";
import UserContext from "contexts/userContext";
import useAssignInventoryAdjustments from "../../hooks/useAssignInventoryAdjustments";
import {
  InventoryAdjustment,
  InventoryAdjustmentStatusCode,
} from "../../types/inventoryAdjustments";

const assignStatuses: InventoryAdjustmentStatusCode[] = [
  InventoryAdjustmentStatusCode.Submitted,
  InventoryAdjustmentStatusCode.InReview,
  InventoryAdjustmentStatusCode.Reviewed,
];

interface Props {
  canAssign?: boolean;
  inventoryAdjustment: InventoryAdjustment;
  assigneeName?: string;
  assigneeId?: string | number;
}

const AssigneeInventoryAdjustmentSelect = ({
  canAssign = true,
  inventoryAdjustment,
  assigneeName,
  assigneeId,
}: Props) => {
  const { overallAdjustmentId, statusCode } = inventoryAdjustment;
  const { userId: currentUserId } = useContext(UserContext)!;
  const [changeAssignee] = useAssignInventoryAdjustments();

  const isAssignable: boolean = useMemo(
    () => canAssign && assignStatuses.includes(statusCode),
    [statusCode, canAssign]
  );
  const isAssigned = !!assigneeId;

  const onChange = (newAssigneeId: string | number | null) => {
    changeAssignee({
      ids: [overallAdjustmentId],
      assigneeId: newAssigneeId,
    });
  };

  return (
    <AssigneeSelector
      entityId={overallAdjustmentId.toString()}
      isAssignable={isAssignable}
      isUnAssignable={false}
      isAssigned={isAssigned}
      loadOnlyActive={true}
      currentUserId={currentUserId}
      assigneeId={String(assigneeId)}
      assigneeName={assigneeName}
      onChange={onChange}
    />
  );
};

export default AssigneeInventoryAdjustmentSelect;
